export default "__VITE_ASSET__0558f779__"